import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ManageRightFilesForm from './ManageRightFilesForm'
import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'

import useManageDrawer from '../../../../hooks/formHooks/useManageDrawer'
import { toString } from '../../../../helpers/common'

import { formItemIdSelector } from '../../../../modules/selectors/forms'
import { rightsListSelector, rightsListIsLoadingSelector } from '../../../../modules/selectors/rights'
import { choicesAllocationUnitsWasLoadedSelector } from '../../../../modules/selectors/choices'
import { getChoicesAllocationUnits } from '../../../../modules/actions/choices'

import { RIGHT_MANAGE_FILES } from '../../../../constants/forms'

function ManageRightFiles() {
  const dispatch = useDispatch()

  const rightsList = useSelector(rightsListSelector)
  const { [RIGHT_MANAGE_FILES]: selectedRightId } = useSelector(formItemIdSelector)
  const rightsListIsLoading = useSelector(rightsListIsLoadingSelector)
  const choicesAllocationUnitsWasLoaded = useSelector(choicesAllocationUnitsWasLoadedSelector)

  const selectedRight = rightsList.find(right => toString(right.id) === toString(selectedRightId))

  const { isFormOpen } = useManageDrawer({
    formName: RIGHT_MANAGE_FILES
  })

  useEffect(() => {
    if (isFormOpen && !choicesAllocationUnitsWasLoaded) {
      dispatch(getChoicesAllocationUnits())
    }
  }, [dispatch, isFormOpen, choicesAllocationUnitsWasLoaded])

  return (
    <FormDrawerWrapper
      formName={RIGHT_MANAGE_FILES}
      title="Manage file uploads"
      isInitialDataLoading={rightsListIsLoading}
      showOpenButton={false}
    >
      <ManageRightFilesForm selectedRight={selectedRight} formName={RIGHT_MANAGE_FILES} />
    </FormDrawerWrapper>
  )
}

export default ManageRightFiles
